import { createFileRoute } from "@tanstack/react-router";
import { PermissionGate } from "@/shared/auth/PermissionGate";
import { tienePermisoEnSesion } from "@/shared/auth/permiso-en-sesion";
import { PERMISOS } from "@/lib/permisos";
import { ErrorAlert } from "@/components/ui";
import { AdminIndicadoresImpuestoPage } from "@/features/admin-indicadores-impuesto/components/AdminIndicadoresImpuestoPage";
import { indicadoresImpuestoAdminQueryOptions } from "@/features/admin-indicadores-impuesto/hooks/use-indicadores-impuesto-admin";

/**
 * Ruta `/admin/indicadores-impuesto` · CRUD del catálogo de indicadores de
 * impuesto SAP (V0/V5/V7 · P45). Sin paginación (catálogo corto).
 */
export const Route = createFileRoute("/_authed-tw/admin/indicadores-impuesto")({
  loader: ({ context: { queryClient } }) =>
    tienePermisoEnSesion([PERMISOS.adminIndicadoresImpuesto])
      ? queryClient.ensureQueryData(indicadoresImpuestoAdminQueryOptions)
      : undefined,
  component: () => (
    <PermissionGate permisos={[PERMISOS.adminIndicadoresImpuesto]}>
      <AdminIndicadoresImpuestoPage />
    </PermissionGate>
  ),
  errorComponent: ({ error }) => <ErrorAlert error={error} />,
});
